import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, ShieldCheck, Users } from 'lucide-react';
import { Button } from './ui/Button';
import { Section } from './ui/Section';
import { Link } from 'react-router-dom';
export function Hero() {
  return <div className="relative overflow-hidden bg-slate-50 pt-16 pb-16 md:pt-32 md:pb-24" data-id="element-162" data-mp="9ipbb96819z2">
      {/* Background Pattern */}
      <div className="absolute inset-0 z-0 opacity-[0.03]" style={{
      backgroundImage: 'radial-gradient(#1a061f 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-163" data-mp="129h0hmovcycw"></div>

      <Section className="relative z-10 !py-0" data-id="element-164" data-mp="sai535t46z7u">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-165" data-mp="sde3ev8vjpwt">
          {/* Left: Text Content */}
          <div className="text-center lg:text-left" data-id="element-166" data-mp="nekqb3xi20x6">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-brand-primary/20 text-brand-primary text-sm font-medium mb-8" data-id="element-167" data-mp="3d2bhzk51cpsw">
              <ShieldCheck className="w-4 h-4" data-id="element-168" data-mp="39cpfl1np9x62" />
              <span data-id="element-169" data-mp="3e8ecex8c4zyo">Trusted by 5,000+ Students & Parents</span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-5xl md:text-7xl font-bold tracking-tight text-brand-dark mb-6" data-id="element-170" data-mp="30hrjxmt646b1">
              Student Housing,{' '}
              <span className="text-brand-primary" data-id="element-171" data-mp="2hlj983hdz38c">Verified.</span>
              <br data-id="element-172" data-mp="2lk8usjckvr32" />
              Roommates, <span className="text-brand-primary" data-id="element-173" data-mp="2lml8gkbazfab">Matched.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed" data-id="element-174" data-mp="s44ifoom7nif">
              The only platform that combines physical hostel verification with
              AI-driven roommate pairing to ensure a safe, fraud-free campus
              experience.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto justify-center lg:justify-start" data-id="element-175" data-mp="x14o3yhjyo90">
              <Link to="/find-hostel" className="w-full sm:w-auto" data-id="element-176" data-mp="21a4txwhwuk6i">
                <Button size="lg" className="w-full group" data-id="element-177" data-mp="269zj9vm1f1pg">
                  Find a Verified Hostel
                  <ArrowRight className="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-178" data-mp="2b0pptc679alq" />
                </Button>
              </Link>
              <Link to="/roommate-match" className="w-full sm:w-auto" data-id="element-179" data-mp="2fz101o0epn4h">
                <Button variant="outline" size="lg" className="w-full" data-id="element-180" data-mp="2ky43x54nhnav">
                  <Users className="mr-2 w-5 h-5" data-id="element-181" data-mp="2p0h7bmvxd94h" />
                  Match with a Roommate
                </Button>
              </Link>
            </motion.div>

            {/* Government Backing */}
            <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="mt-10 flex justify-center lg:justify-start" data-id="element-182" data-mp="umhekdqvqnpe">
              <div className="inline-flex items-center gap-4 bg-white border border-slate-200 rounded-2xl pl-4 pr-5 py-3 shadow-sm" data-id="element-183" data-mp="e9jx5t0ct7rd">
                <img src="https://cdn.magicpatterns.com/uploads/8iDDWdAud2hPPyMisCfFjJ/IMG_0021.png" alt="Federal Ministry of Education" className="h-8 w-auto" data-id="element-184" data-mp="9a79j61nrwnq" />
                <div className="text-left border-l border-slate-200 pl-4" data-id="element-185" data-mp="3ct0o9m66arjh">
                  <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500" data-id="element-186" data-mp="3rh550klo0szm">
                    Backed by
                  </div>
                  <div className="text-sm font-bold text-brand-dark" data-id="element-187" data-mp="2yzsupoyj7lz5">
                    Federal Ministry of Education
                  </div>
                </div>
              </div>
            </motion.div>

            {/* Trust Indicators */}
            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.8,
            delay: 0.5
          }} className="mt-16 pt-8 border-t border-slate-200" data-id="element-188" data-mp="19hvnsszl0xae">
              <p className="text-sm font-semibold text-slate-500 uppercase tracking-wider mb-6" data-id="element-189" data-mp="1s95a62ugbgje">
                Ensuring Safety Across Top Campuses
              </p>
              <div className="flex flex-wrap justify-center lg:justify-start gap-8 md:gap-16 opacity-60 grayscale hover:grayscale-0 transition-all duration-500" data-id="element-190" data-mp="1x7q27ezjutwr">
                <span className="text-xl font-bold text-brand-dark" data-id="element-191" data-mp="1n9ak21ii2uze">FUTA</span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-192" data-mp="7tjt2uc1gqg5">
                  UNILAG
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-193" data-mp="bv5cyzmzq4zu">
                  COVENANT
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-194" data-mp="2eg90ygbilx68">
                  BABCOCK
                </span>
                <span className="text-xl font-bold text-brand-dark" data-id="element-195" data-mp="29izcp3zv3rjz">UI</span>
              </div>
            </motion.div>
          </div>

          {/* Right: Hostel Image */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="relative hidden lg:block" data-id="element-196" data-mp="1zrmoqnh6plj8">
            <div className="relative" data-id="element-197" data-mp="1lupx4jt8s01a">
              <img src="https://cdn.magicpatterns.com/uploads/wDxVU5ewHBAbGV4M9CD8C1/Copy_of_Billvast_Shirt_Mock-up_.png" alt="Verified Student Hostel" className="w-full h-auto max-w-md mx-auto drop-shadow-2xl" data-id="element-198" data-mp="1gulhew05r9c4" />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-4 shadow-xl" data-id="element-199" data-mp="3jp3hosswhzfm">
                <div className="flex items-center gap-2 mb-1" data-id="element-200" data-mp="3nqfa1635syri">
                  <ShieldCheck className="w-5 h-5 text-emerald-600" data-id="element-201" data-mp="3nom3dqsjqeji" />
                  <span className="font-bold text-brand-dark" data-id="element-202" data-mp="3si6r8q0fds4z">Verified</span>
                </div>
                <div className="text-sm text-slate-500" data-id="element-203" data-mp="19sw9yr56e3n">850+ Properties</div>
              </div>
            </div>
          </motion.div>
        </div>
      </Section>
    </div>;
}